exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-container-2{display:grid;grid-template-columns:1fr 1fr;width:100%;height:80vh;margin-bottom:600px}", ""]);

// exports
